import React from 'react'
import PropTypes from 'prop-types'

const PadlockIcon = ({
  color,
  width = '100%',
  height = '100%',
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 19" fill="none">
    <path d="M8.16414 0.70166C9.37252 0.70166 10.5314 1.18168 11.3858 2.03613C12.2403 2.89058 12.7203 4.04946 12.7203 5.25783V7.99154C13.4453 7.99154 14.1407 8.27955 14.6533 8.79222C15.166 9.30489 15.454 10.0002 15.454 10.7252V16.1926C15.454 16.9177 15.166 17.613 14.6533 18.1257C14.1407 18.6383 13.4453 18.9264 12.7203 18.9264H3.60797C2.88295 18.9264 2.18762 18.6383 1.67495 18.1257C1.16228 17.613 0.874268 16.9177 0.874268 16.1926V10.7252C0.874268 10.0002 1.16228 9.30489 1.67495 8.79222C2.18762 8.27955 2.88295 7.99154 3.60797 7.99154V5.25783C3.60797 4.04946 4.088 2.89058 4.94244 2.03613C5.79689 1.18168 6.95577 0.70166 8.16414 0.70166ZM8.16414 11.6365C7.70436 11.6363 7.26151 11.81 6.92437 12.1226C6.58723 12.4353 6.38072 12.8638 6.34623 13.3223L6.34168 13.4589C6.34168 13.8194 6.44856 14.1718 6.64882 14.4715C6.84907 14.7712 7.1337 15.0047 7.46672 15.1427C7.79973 15.2806 8.16617 15.3167 8.51969 15.2464C8.87322 15.1761 9.19795 15.0025 9.45283 14.7476C9.7077 14.4927 9.88128 14.168 9.9516 13.8145C10.0219 13.461 9.98583 13.0945 9.84789 12.7615C9.70995 12.4285 9.47636 12.1439 9.17665 11.9436C8.87695 11.7434 8.5246 11.6365 8.16414 11.6365ZM8.16414 2.52413C7.43912 2.52413 6.74379 2.81214 6.23112 3.32481C5.71845 3.83748 5.43044 4.53281 5.43044 5.25783V7.99154H10.8978V5.25783C10.8978 4.53281 10.6098 3.83748 10.0972 3.32481C9.5845 2.81214 8.88917 2.52413 8.16414 2.52413Z" fill={color} />
  </svg>

)

PadlockIcon.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  color: PropTypes.string,
}

PadlockIcon.defaultProps = {
  width: 20,
  height: 20,
  color: 'currentColor',
}

export default PadlockIcon
